import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const UnvalidatedPhotosRedux = createActions(
  {
    deleteRequest: ['photoId'],
    deleteSuccess: ['data'],
    deleteFailure: ['errors'],
    validateRequest: ['photoId'],
    validateSuccess: ['data'],
    validateFailure: ['errors'],
  },
  {
    prefix: 'UNVALIDATED_PHOTOS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = UnvalidatedPhotosRedux
export const UnvalidatedPhotosTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

const validateRequest = state => state.merge({ get: { fetching: true } }, DEEP)
const validateSuccess = (state, { data }) =>
  state.merge({ get: { fetching: false, results: { data } } }, DEEP)
const validateFailure = (state, { errors }) =>
  state.merge({ get: { fetching: false }, ...errors }, DEEP)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.deleteRequest]: validateRequest,
  [Types.deleteSuccess]: validateSuccess,
  [Types.deleteFailure]: validateFailure,
  [Types.validateRequest]: validateRequest,
  [Types.validateSuccess]: validateSuccess,
  [Types.validateFailure]: validateFailure,
},
{
  defaultActions: {
    get: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/UnvalidatedPhotosRedux.js